export default "__VITE_ASSET__CJlAJy5w__"